import React, { useEffect, useState } from 'react';

interface SplashScreenProps {
  onComplete: () => void;
}

const SplashScreen: React.FC<SplashScreenProps> = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const currentDomain = window.location.hostname;
      const targetDomain = 'projectlumina.online';
      
      if (currentDomain !== targetDomain) {
        setIsRedirecting(true);
        setTimeout(() => {
          window.location.href = `https://${targetDomain}${window.location.pathname}${window.location.search}${window.location.hash}`;
        }, 1500);
        return;
      }
    }
  }, []);

  useEffect(() => {
    if (isRedirecting) return;

    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        setIsVisible(false);
        onComplete();
      }, 500);
    }, 2500);

    return () => clearTimeout(timer);
  }, [onComplete, isRedirecting]);

  if (!isVisible) return null;

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <div className="splash-content">
        <div className="wifi-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* WiFi Signal Bars */}
            <path 
              className="wifi-bar wifi-bar-1" 
              d="M12 20h.01M8.5 16.5a5 5 0 0 1 7 0" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
            <path 
              className="wifi-bar wifi-bar-2" 
              d="M5.5 13.5a9 9 0 0 1 13 0" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
            <path 
              className="wifi-bar wifi-bar-3" 
              d="M2.5 10.5a13 13 0 0 1 19 0" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="loading-text">
          {isRedirecting ? 'Redirecting...' : 'Connecting...'}
        </div>
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;